<script setup lang="ts">
import './tag.css';
import '@sg-core/src/View/Components/Atoms/Box/box.css';

export interface PhxsgTagProps {
  spacing?: number | string;
  use?: string;
}

const { spacing = 1, use = 'div' } = defineProps<PhxsgTagProps>();
</script>

<template>
  <component
    :is="use"
    :class="['phxsg-box phxsg-box--solid phxsg-tag title-caption', { [`phxsg-box--spacing-${spacing}`]: spacing }]"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>
